import { render, staticRenderFns } from "./BadgesItem.vue?vue&type=template&id=69a89336"
import script from "./BadgesItem.vue?vue&type=script&lang=js"
export * from "./BadgesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports